export default __webpack_public_path__ + "static/media/not-chilli.36535af1.jpeg";